<template>
  <div class="vue-dropzone-box">
    <vue-dropzone
      :id="'vd' + partId"
      class="dropzone-root"
      :key="partId"
      :options="dropzoneOptions"
      :useCustomSlot=true
      @vdropzone-file-added="fileAdded"
    >
      <div class="dz-content">
        <img class="dz-image" src="@/assets/emptyimage.png">
        <div class="btn-wrapper">
          <button type="button" class="dz-btn normal-btn add" @click.stop.prevent="onClickInsertButton">新規追加</button>
          <button type="button" class="dz-btn normal-btn select" @click.stop.prevent="onClickSelectButton">画像選択</button>
        </div>
        <portal v-if="isShowUploadPopup" to="modal1">
          <upload-popup
            :ids="ids"
            :isCallByEditor="true"
            :isShowTabPanel="true"
            @reflectImage="reflectImage"
            @close="isShowUploadPopup = false"
          />
        </portal>
        <portal v-if="isShowImageManager" to="modal1">
          <image-manager-popup
            @reflectImage="reflectImage"
            @close="isShowImageManager = false"
          />
        </portal>
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import Vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import constants from '@/constants'
import UploadPopup from '@/components/ImageManager/UploadPopup'
import ImageManagerPopup from '@/components/ImageManager/ImageManagerPopup'

export default {
  props: [
    'partId',
    'partsContainerId',
    'sectionId',
    'partWidth',
    'horizontalDisplayRatio',
  ],
  components: {
    VueDropzone: Vue2Dropzone,
    UploadPopup,
    ImageManagerPopup,
  },
  data () {
    return {
      isShowUploadPopup: false,
      isShowImageManager: false,
      loading: false,
      dropzoneOptions: {
        maxFilesize: constants.uploadMaxSizeMB,
        acceptedFiles: 'image/*',
        url: 'required',
        autoProcessQueue: false,
        maxFiles: 1,
      }
    }
  },
  computed: {
    ids () {
      return {
        partId: this.partId,
        partsContainerId: this.partsContainerId,
        sectionId: this.sectionId,
      }
    },
    partsContainerType () {
      // パーツタイプを取得
      return this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId).type
    },
  },
  mounted () {
    this.setEmptyImage()
  },
  methods: {
    setEmptyImage () {
      this.$emit('updateSectionHeight')
      // 何の画像も設定されていなかったら、空画像を入れる
      const oriAttrs = this.$store.getters.findPartAttrs(this.sectionId, this.partsContainerId, this.partId)
      if (!oriAttrs.src) {
        const emptyImageKey = this.partsContainerType === 'Logo' ? 'emptyLogoImage' : 'emptyImage'
        // 空画像の幅を計算
        // 画像カードで、表示比率が画像2 テキスト1の場合: 画像の方が大きい状態が正しいためパーツ最大幅(partWidth)を採用
        // 上記以外の場合: パーツの幅をはみ出さないように、constantsとパーツ最大幅(partWidth)の値を比較して小さい方を採用
        let width
        if (this.horizontalDisplayRatio === 'imageTwoToTextOne') {
          width = Number(this.partWidth.replace(/px/g, ''))
        } else if (constants[emptyImageKey].width >= Number(this.partWidth.replace(/px/g, ''))) {
          width = Number(this.partWidth.replace(/px/g, ''))
        } else {
          width = constants[emptyImageKey].width
        }
        this.$store.commit('updatePart', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          partId: this.partId,
          attrs: {
            'data-key': null, // data-keyが指定されていない時、空画像が指定されていると判断する
            src: constants[emptyImageKey].url,
            width: width + 'px',
            height: constants[emptyImageKey].height + 'px',
          },
          styles: {
            'text-align': 'center',
          }
        })
      }
    },
    fileAdded (file) {
      this.loading = true
      const sizeMB = Math.floor(file.size / 1000 / 1000)
      if (constants.uploadMaxSizeMB < sizeMB) {
        return this.$store.commit('showErrorMessagePopup', [`${file.name}(${sizeMB}MB)は`, `アップロード可能サイズ(${constants.uploadMaxSizeMB}MB)を超えています`])
      }
      const formData = new FormData()
      formData.append('file', file, file.name)
      formData.append('contentId', this.$route.params.id)
      formData.append('uploadPlaces[]', 'origin')
      formData.append('uploadPlaces[]', 'content')
      this.$http({
        url: '/image/upload',
        type: 'POST',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          let image = json.data.image[0]
          image.url = decodeURIComponent(image.url)
          this.setImageAttr(image)
          this.loading = false
        }
      })
    },
    openImagePalette () {
      this.$store.commit('updateStatusPalette', {
        type: 'Image',
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
      })
    },
    onClickInsertButton () {
      // ポップアップ時に画像のpaletteを開いておく
      this.openImagePalette()
      this.isShowUploadPopup = true
    },
    onClickSelectButton () {
      // ポップアップ時に画像のpaletteを開いておく
      this.openImagePalette()
      this.isShowImageManager = true
    },
    reflectImage (image) {
      this.$store.dispatch('reflectImage', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        attrs: this.$utils.image.getImageAttrs(image.image),
      })
    }
  },
  watch: {
    'horizontalDisplayRatio' () {
      this.setEmptyImage()
    }
  },
}
</script>
<style lang="scss">
.vue-dropzone-box {
  // 以下、設定しないとセクションのスタイル設定が反映されてしまう
  font-size: 1rem;
  line-height: normal;
  .vue-dropzone {
    padding: 20px 0px;
    background-color: #f8f8f8;
    border: 2px dashed #E5E5E5;
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    color: #777;
    min-height: 235px;
    cursor: pointer;
    pointer-events: none; // ポップアップに画像を反映する機能ができるまで、一時的にクリックできないように
    cursor: default;
    .dz-content {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .dz-image {
      width: 50px;
      margin-bottom: 5px;
    }
    .dz-text {
      color: #555;
      margin: 5px 0 5px 0;
    }
    .btn-wrapper {
      .dz-btn {
        outline: none;
        pointer-events: all;
        cursor: pointer;
        border: solid 1px #c6c6c6;
        border-radius: 5px;
        color: $commonFontColor;
        height: 30px;
        width: 90px;
        line-height: 28px;
        background: inherit;
        text-align: center;
        font-size: 12px;
        padding: 0 10px;
        transition: all 0.3s ease 0s;
        &:hover, &:active {
          background: #e4e4e4;
          overflow: hidden;
        }
        &::before {
          padding-right: 8px;
          font-size: 14px;
          font-family: "Font Awesome 5 Free";
          font-weight: 900;
        }
        &.add {
          margin: 0 5px 10px;
          &::before {
            content: '\f574';
          }
        }
        &.select {
          margin: 0 5px 0;
          &::before {
            content: '\f276';
          }
        }
      }
    }
    .dz-message {
      display: block;
      text-align: center;
      padding: 20px 0 20px 0;
    }
    .dz-preview, .dz-success-mark, .dz-error-mark {
      display: none;
    }
  }
}
</style>
